import { motion } from "framer-motion";

const heroLines = [
  { text: "Notre solution ?", className: "text-[#1a1918]" },
  { text: "Vous aider à sortir de la crise", className: "text-[#ce1e20]" },
  { text: "Repartir plus fort", className: "italic text-[#1a1918]" },
];

const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="mask-line">
    <motion.span
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, ease: [0.77, 0, 0.175, 1], delay }}
      className={className}
    >
      {children}
    </motion.span>
  </span>
);

const openUrgencePanel = () => {
  window.dispatchEvent(new Event("prosecours:open-urgence"));
  document
    .querySelector('[data-testid="urgence-end-section"]')
    ?.scrollIntoView({ behavior: "smooth", block: "end" });
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden bg-[#f7f5f0] pt-16 md:pt-20"
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.2 }}
        className="absolute inset-0"
        data-testid="hero-banner"
      >
        <img
          src="/hero-equipe.webp"
          alt="Préparation de formalités juridiques avec l'équipe ProSecours"
          className="h-full w-full scale-110 object-cover blur-md"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#f7f5f0]/95 via-[#f7f5f0]/75 to-[#f7f5f0]/30" />
      </motion.div>

      <div className="relative z-10 mx-auto flex min-h-[calc(100vh-4rem)] w-full max-w-[1440px] items-center px-6 py-16 md:min-h-[calc(100vh-5rem)] md:px-14 md:py-24">
        <div className="max-w-4xl text-[#1a1918]">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="overline text-[#1a1918]/65"
          >
            <span
              data-testid="hero-meta-tagline"
              className="inline-flex items-center text-[#1a1918]/80"
            >
              <span className="mr-2 inline-block h-2 w-2 rounded-full bg-[#ce1e20]" />
              Formalités d'entreprise • Assistance aux démarches • Prévention
              des difficultés • Dépôt auprès du greffe compétent
            </span>
          </motion.div>

          <h1
            data-testid="hero-title"
            className="mt-8 font-serif-ed text-[12vw] leading-[0.98] tracking-tighter md:text-[6vw] lg:text-[5vw]"
          >
            {heroLines.map((line, i) => (
              <MaskedLine
                key={line.text}
                delay={0.5 + i * 0.13}
                className={line.className}
              >
                {line.text}
              </MaskedLine>
            ))}
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.05, duration: 0.9 }}
            data-testid="hero-slogan"
            className="mt-6 font-serif-ed text-xl text-[#1a1918] md:mt-8 md:text-2xl"
          >
            ProSecours{" "}
            <span className="italic text-[#1a1918]/75">
              « Le réflexe des dirigeants »
            </span>
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 1.2, duration: 0.9 }}
            className="mt-10 md:mt-12"
          >
            <button
              type="button"
              onClick={openUrgencePanel}
              data-testid="hero-cta-urgence"
              aria-label="Ouvrir le panneau d'urgence téléphonique"
              className="group inline-flex w-full items-center justify-between gap-4 bg-[#ce1e20] px-6 py-5 text-white transition-colors duration-300 hover:bg-[#a71518] sm:w-auto sm:min-w-[360px]"
            >
              <span className="text-left font-serif-ed text-2xl italic md:text-3xl">
                Décrire ma démarche
              </span>
              <span className="text-2xl transition-transform duration-300 group-hover:translate-x-1">
                →
              </span>
            </button>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
